module.exports = __webpack_public_path__ + "img/recent-articles-bg.19881f68.webp";